enum AuthMode {
  SMS = 'sms',
  EMAIL = 'email',
}
const DEFAULT_AUTH_MODE = AuthMode.SMS;

const isAuthModeValid = (mode: string) => Object.values(AuthMode).includes(mode as AuthMode);

export { AuthMode, DEFAULT_AUTH_MODE, isAuthModeValid };
